export const queuelist1 = [
  { id: 1, name: "chip เชื้อเพลิง", amount: 11, max: 15 },
  { id: 2, name: "ไม้ชิพรถกล่อง AA", amount: 1, max: 4 },
  { id: 3, name: "กะลาปาล์ม", amount: 4, max: 4 },
];
export const queuelist2 = [
  { id: 5, name: "ลานโกดัง", amount: 2, max: 8 },
  { id: 6, name: "อื่นๆ", amount: 10, max: 10 },
];
export const listedit = [
  {
    id: 1,
    name: "แก้ไขโปรไล์ลูกค้า",
    icon: "fa fa-user-circle",
    color: "btn btn-primary position-relative",
    count: "10",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editcustomer",
  },
  {
    id: 2,
    name: "แก้ไขชื่อลูกค้า",
    icon: "fa fa-cubes",
    color: "btn btn-info position-relative",
    count: "20",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "cardeditproduct",
  },
  {
    id: 3,
    name: "แก้ไข DO",
    icon: "fa fa-user-secret",
    color: "btn btn-secondary position-relative",
    count: "15",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editdo",
  },
  {
    id: 4,
    name: "เปลี่ยนลูกค้า",
    icon: "fa fa-users",
    color: "btn btn-success position-relative",
    count: "14",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "changcustomer",
  },
  {
    id: 5,
    name: "แก้ไขข้อมูลรถ",
    icon: "fa fa-truck",
    color: "btn btn-warning position-relative",
    count: "12",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editcar",
  },
  {
    id: 6,
    name: "แก้ไขวัตถุประสงค์",
    icon: "fa fa-cogs",
    color: "btn btn-btn btn-danger btn-sm  position-relative",
    count: "84",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center ",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editobjective",
  },
];
export const datausers = [
  {
    id: 1,
    name: "นางปราณี มีสุข",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-warning btn-sm m-2",
    approve: "รออนุมัติ",
    bankname: "กรุงไทย",
    icon: "bi bi-bookmark-star-fill me-2",
  },
  {
    id: 2,
    name: "นางสุวันนะ วิชา",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    approve: "ไม่อนุมัติ",
    color: "btn btn-danger btn-sm m-2",
    bankname: "กรุงไทย",
    icon: "bi bi-x-circle me-2",
  },
  {
    id: 3,
    name: "นางการาการ มหาโหรา",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-success btn-sm m-2",
    approve: "อนุมัติแล้ว",
    bankname: "กรุงไทย",
    icon: "bi bi-check-circle-fill me-2",
  },
  {
    id: 4,
    name: "นางใจ สุดกลาง",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-warning btn-sm m-2",
    approve: "รออนุมัติ",
    bankname: "กรุงไทย",
    icon: "bi bi-bookmark-star-fill me-2",
  },
  {
    id: 5,
    name: "นางวิหาร ฝันดี",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-warning btn-sm m-2",
    approve: "รออนุมัติ",
    bankname: "กรุงไทย",
    icon: "bi bi-bookmark-star-fill me-2",
  },
  {
    id: 6,
    name: "นางสาวพัชราภา ชัยชนะ",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-danger btn-sm m-2",
    approve: "ไม่อนุมัติ",
    bankname: "กรุงไทย",
    icon: "bi bi-x-circle me-2",
  },
  {
    id: 7,
    name: "นางสำรวย สุดรวย",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-success btn-sm m-2",
    approve: "อนุมัติแล้ว",
    bankname: "กรุงไทย",
    icon: "bi bi-check-circle-fill me-2",
  },
  {
    id: 8,
    name: "นางอำนรว มวยหก",
    codeID: "1547542",
    IdentityID: "145785467144",
    typeUser: "บุคคลธรรมดา",
    No: "1",
    Moo: "2",
    tumbol: "หนองเม็ก",
    umper: "หนองกรุงศรี",
    province: "ปราจีนบุรี",
    codenumber: "25478",
    tel: "085-8642575",
    bookname: "นางปราณี มีสุข",
    booknumber: "254687542645",
    subbank: "ปราจีนบุรี",
    color: "btn btn-danger btn-sm m-2",
    approve: "ไม่อนุมัติ",
    bankname: "กรุงไทย",
    icon: "bi bi-x-circle me-2",
  },
];
export const dataproduct = [
  {
    id: 1,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
  {
    id: 2,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
  {
    id: 3,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
  {
    id: 4,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
  {
    id: 5,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
  {
    id: 6,
    number: "812-640802455",
    ProductType: "ไม้ท่อน",
    ProductName: "ชิพละเอียด",
    store: "1",
    startProduct: "ท่าตูม",
    company: "สยามวู้ดชิพ",
    endProduct: "ปราจีนบุรี",
    comment: "เรียบร้อยดี",
  },
];
export const weigthlist = [
  {
    id: 3,
    name: "ห้องชั่ง E85",
    icon: "bi bi-truck text-dark",
    color: "badge bg-info text-dark fs-3 mt-2",
    count: "15",
    cctv: "กล้องดับ",
    program: "ปิดโปรแกรม",
    in: "ขาเข้า",
    out: "ขาออก",
    truckin: "มีรถบนแท่นชั่ง",
    truckout: "ไม่มีรถบนแท่นชั่ง",
    offweigth: "ปิดแท่นชั่ง",
    badge: "badge rounded-pill bg-info fs-6 text-dark mt-2",
    bg: "col-lg-3 d-flex align-items-center bg-info d-flex justify-content-center badge my-2",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editdo",
  },
  {
    id: 4,
    name: "ห้องชั่ง BIO",
    icon: "bi bi-truck text-dark",
    color: "badge bg-warning text-dark fs-3 ",
    count: "14",
    cctv: "กล้องดับ",
    program: "ปิดโปรแกรม",
    in: "ขาเข้า",
    out: "ขาออก",
    truckin: "มีรถบนแท่นชั่ง",
    truckout: "ไม่มีรถบนแท่นชั่ง",
    offweigth: "ปิดแท่นชั่ง",
    badge: "badge rounded-pill bg-warning fs-6 text-dark  mt-2",
    bg: "col-lg-3 d-flex align-items-center bg-warning d-flex justify-content-center badge my-2",
    in1: "25",
    out1: "36",
    success: "58",
    link: "changcustomer",
  },
  {
    id: 5,
    name: "ห้องชั่ง COYARD",
    icon: "bi bi-truck text-light",
    color: "badge bg-secondary  fs-3 mt-2",
    count: "12",
    cctv: "กล้องดับ",
    program: "ปิดโปรแกรม",
    in: "ขาเข้า",
    out: "ขาออก",
    truckin: "มีรถบนแท่นชั่ง",
    truckout: "ไม่มีรถบนแท่นชั่ง",
    offweigth: "ปิดแท่นชั่ง",
    badge: "badge rounded-pill  bg-secondary fs-6 mt-2",
    bg: "col-lg-3 d-flex align-items-center bg-secondary d-flex justify-content-center badge my-2",
    in1: "25",
    out1: "36",
    success: "58",
    link: "editcar",
  },
];
export const weigthlistaa = [
  {
    id: 1,
    name: "ห้องชั่ง AA",
    icon: "bi bi-truck text-light",
    color: "badge bg-primary  fs-3 mt-2",
    count: "10",
    cctv: "กล้องดับ",
    program: "ปิดโปรแกรม",
    in: "ขาเข้า",
    out: "ขาออก",
    truckin: "มีรถบนแท่นชั่ง",
    truckout: "ไม่มีรถบนแท่นชั่ง",
    offweigth: "ปิดแท่นชั่ง",
    badge: "badge rounded-pill bg-primary fs-6 mt-2",
    bg: "col-lg-3 d-flex align-items-center bg-primary d-flex justify-content-center badge my-2 ",
    in1: "25",
    out1: "36",
    success: "58",
    spanA: "fs-5  text-primary  fw-bold",
    link: "editcustomer",
  },
  {
    id: 2,
    name: "ห้องชั่ง PM3",
    icon: "bi bi-truck text-light",
    color: "badge bg-success  fs-3 mt-2",
    count: "20",
    cctv: "กล้องดับ",
    program: "ปิดโปรแกรม",
    in: "ขาเข้า",
    out: "ขาออก",
    truckin: "มีรถบนแท่นชั่ง",
    truckout: "ไม่มีรถบนแท่นชั่ง",
    offweigth: "ปิดแท่นชั่ง",
    badge: "badge rounded-pill bg-success fs-6  mt-2",
    bg: "col-lg-3 d-flex align-items-center bg-success d-flex justify-content-center badge my-2",
    in1: "25",
    out1: "36",
    success: "58",
    spanA: "fs-5  text-success fw-bold ",
    link: "cardeditproduct",
  },
];
export const cardsupplier = [
  {
    id: 1,
    name: "สำรวย คงวิชา",
    status: "online",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    company: "บริษัทเหล็กหล่อ",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=547286&size=320",
  },
  {
    id: 2,
    name: "พรวิไล งานช้าง",
    status: "online",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    company: "บริษัทเหล็กหล่อ",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=18492872&size=320",
  },
  {
    id: 3,
    name: "พันนิภา สาขากร",
    status: "online",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    company: "บริษัทเหล็กหล่อ",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=630002&size=320",
  },
  {
    id: 4,
    name: "นอนมา สุดกลาง",
    status: "online",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    company: "บริษัทเหล็กหล่อ",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=	15229&size=320",
  },
  {
    id: 5,
    name: "อรวรรณ ทิพย์คงสา",
    status: "online",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    company: "บริษัทเหล็กหล่อ",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=	591107&size=320",
  },
];
export const request = [
  {
    id: 1,
    name: "สำรวย คงวิชา",
    title: "แก้ไขหน้าส่งสินค้า",
    discription: "แก้ไขเพิ่มเติมให้สามารถลงทะเบียนออนไลน์และเพิ่มรูปได้",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=547286&size=320",
  },
  {
    id: 2,
    name: "พรวิไล งานช้าง",
    title: "แก้ไขหน้าแจ้งคิว",
    discription: "แก้ไขให้สามารถเพิ่มคิวได้",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=18492872&size=320",
  },
  {
    id: 3,
    name: "พันนิภา สาขากร",
    title: "แก้ไขหน้าจองคิว",
    discription: "แก้ไขให้สามารถจองคิวได้",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=630002&size=320",
  },
  {
    id: 4,
    name: "นอนมา สุดกลาง",
    title: "แก้ไขหน้าคนเข้าโรงงาน",
    discription:
      "แก้ไขหน้าให้เพิ่มรูปได้",
    startdate: "11-05-2564",
    enddate: "11-05-2565",

    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=	15229&size=320",
  },
  {
    id: 5,
    name: "อรวรรณ ทิพย์คงสา",
    title: "แก้ไขหน้ารถเข้าโรงงาน",
    discription:
      "ให้สามารถเพิ่มจำนวนรถได้",
    startdate: "11-05-2564",
    enddate: "11-05-2565",
    image:
      "https://wms.advanceagro.net/WSVIS/api/Face/GetImage?CardID=	591107&size=320",
  },
];
